// extracted by mini-css-extract-plugin
module.exports = {"dialogHotelOrderDetails":"DialogHotelOrderDetails_dialogHotelOrderDetails_1Wxh_","title":"DialogHotelOrderDetails_title_1edVR"};